<div class="container" [ngStyle]="{'padding-bottom': !onMarketPage ? '300px' : '0'}">
    <div [hidden]="!onMarketPage || onHomePage">
      <h3 class="d-flex justify-content-center lime-green-button text-white rounded-pill p-3 fs-5">
        <fa-icon class="me-2 fa-lg" [icon]="faCow"></fa-icon>Lokalna ponudba
      </h3>
      <div *ngIf="allProducts.length === 0" class="col-12 d-flex justify-content-center" style="color: gray; font-style: italic;">
        <h2 class="text-center my-5">Na žalost ni izdelkov.</h2>
      </div>
    </div>

    <div [hidden]="onMarketPage">
      <h3 class="d-flex justify-content-center lime-green-button text-white rounded-pill p-3 fs-5">
        <fa-icon class="me-2 fa-lg" [icon]="faCow"></fa-icon>Vsi izdelki kmetije
      </h3>
    </div>
    <div class="row g-3">
      <div class="col-md-4 product-item-container" *ngFor="let prod of allProductsShow; let i = index" [ngClass]="{'fade-in': i >= previousVisibleCount}">
        <div class="product-item card d-flex flex-column fixed-card-size p-2">
          <!-- Display the product image -->
          <img [src]="prod.image" alt="Product Image" class="card-img-top" *ngIf="prod.image" style="object-fit: cover; height: 200px;">

          <!-- Display the product name, description, cost, type, and reviews -->
          <div class="card-body d-flex flex-column flex-grow-1">
            <!-- Title and Rating Section -->
            <div class="row mb-2">
              <!-- Title and Rating -->
              <div class="col-12 d-flex justify-content-between align-items-center">
                <div>
                  <h5 class="card-title mb-0">{{ prod.name }}</h5>
                </div>
                <div class="d-flex align-items-center" (click)="openReviewModal($event, prod)" style="cursor: pointer;">
                  <star-rating [starType]="'svg'" [rating]="prod.averageRating ?? 0" [readOnly]="true"></star-rating>
                </div>
              </div>
            </div>

            <!-- Farm name -->
            <div class="row" *ngIf="onMarketPage">
              <p class="card-text farm-name mb-1">
                <fa-icon class="me-2" [icon]="faTractor"></fa-icon>
                <a [routerLink]="['/admin-farm-profile', prod.farmID]" class="invisible-button">{{ prod.farmName}}</a>
              </p>
            </div>
            

            <!-- Comment Section -->
            <div class="row" style="height: 150px">
              <div class="col-12">
                <p class="card-text">
                  {{ getTruncatedProductDescription(prod.description) }}
                  <span *ngIf="prod.description.length > 240">
                    ... <a href="#" (click)="openReviewModal($event, prod)">Preberi več</a>
                  </span>
                </p>
              </div>
            </div>
          </div>

          <!-- Card footer with buttons -->
          <div class="card-footer bg-white d-flex justify-content-between">
            <!-- Edit and Delete buttons (visible only if admin) -->
            <div *ngIf="admin && !onMarketPage">
              <button class="btn btn-link text-secondary" (click)="openUpdateProductModal(prod)">
                <fa-icon class="me-2 fa-lg" [icon]="faEdit"></fa-icon>Uredi
              </button>
              </div>
              <div *ngIf="admin && !onMarketPage">
              <button class="btn btn-danger" (click)="removeProduct(i, prod.productID)">
                <fa-icon class="me-2 fa-lg" [icon]="faTrash"></fa-icon>Odstrani
              </button>
            </div>
            <button class="btn btn-link text-secondary" (click)="openReviewModal($event, prod)">
              <fa-icon class="me-2 fa-lg" [icon]="faStar"></fa-icon>Oceni
            </button>
            <!-- Button 2 with rounded-pill shape -->
            <div *ngIf="onMarketPage || !admin">
              <button id="zanimaMeButton" class="btn btn-sm rounded-pill mt-1" style="background-color: #53AD4B; color: white;" (click)="openContactModal(prod)">
                Zanima me
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="onMarketPage && showLoadMoreButton" class="d-flex justify-content-center mt-3">
      <button class="btn btn-custom" (click)="revealMoreProducts()">
        <fa-icon class="me-3" [icon]="faPlus"></fa-icon>Prikaži več
      </button>
    </div>
    <div class="d-flex justify-content-center mt-3" *ngIf="admin && !onMarketPage">
      <button class="btn btn-custom" (click)="openAddProductModal()">
        <fa-icon class="me-3" [icon]="faPlus"></fa-icon>Dodaj izdelek
      </button>
    </div>
  </div>
